import { format } from 'date-fns'
import React from 'react'

import { DATE_FORMATS } from 'Utils/dates'

import { TrendsTooltipProps } from '../../types'
import { TrendsTooltipStyled } from './TrendsTooltipStyled'

export const TrendsTooltip = ({ value, title, percentInTitle }: TrendsTooltipProps) => {
  const defaultSeriesValue = '0'
  return (
    <TrendsTooltipStyled>
      <li>
        {title} - {value.y ? value.y : defaultSeriesValue} {percentInTitle ? '%' : ''}
      </li>
      <li>{value.x ? format(value.x, DATE_FORMATS.MONTH_DAY_FULL_YEAR) : ''}</li>
    </TrendsTooltipStyled>
  )
}
